<template>
  <div class="page">
    <AppHeader />
    <main>
      <HeroSection />
      <CategoryTiles />
      <OurStory />
      <NewArrivals />
      <HowWeCurate />
      <NewsletterSection />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader.vue'
import HeroSection from '../components/home/HeroSection.vue'
import CategoryTiles from '../components/home/CategoryTiles.vue'
import OurStory from '../components/home/OurStory.vue'
import NewArrivals from '../components/home/NewArrivals.vue'
import HowWeCurate from '../components/home/HowWeCurate.vue'
import NewsletterSection from '../components/home/NewsletterSection.vue'
import SiteFooter from '../components/home/SiteFooter.vue'

export default {
  name: 'HomePage',

  components: {
    AppHeader,
    HeroSection,
    CategoryTiles,
    OurStory,
    NewArrivals,
    HowWeCurate,
    NewsletterSection,
    SiteFooter,
  },
}
</script>

<style scoped>
.page {
  font-family: var(--font);
  color: var(--ink);
  background: var(--canvas);
}
</style>
